import { Slider, Slide } from "../../components/Slider/Slider";
import "swiper/css";
import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";
import { Button } from "../../components/buttons/Button/Button";
import { LabelButton } from "../../components/buttons/LabelButton/LabelButton";
import { Label } from "../../components/Label/Label";
import { SolutionCard } from "../../components/SolutionCard/SolutionCard";
import { InstagramCard } from "../../components/InstagramCard/InstagramCard";
import { CTAForm } from "../../components/Form/CTAForm";
import variant1 from "../../images/icons/headerIcons/variant1.svg";
import folder from "../../images/icons/folder.svg";
import agricultureIcon from "../../images/icons/agricultureIcon.svg";
import plants from "../../images/icons/plants.svg";
import EuropeFlag from "../../images/EuropeFlag.jpg";
import GermanFlag from "../../images/GermanFlag.jpg";
import betinoTitle from "../../images/betinoTitle .jpg";
import wuxalTitle from "../../images/wuxalTitle.jpg";
import fertiplantTitle from "../../images/fertiplantTitle.jpg";
import UniferXTitle from "../../images/UniferXTitle.jpg";
import charts from "../../images/charts.png";
import hero from "../../videos/hero.mp4";
import calendar from "../../images/icons/calendar.svg";
import clock from "../../images/icons/clock.svg";
import blackCalendar from "../../images/icons/blackCalendar.svg";
import blackClock from "../../images/icons/blackClock.svg";
import blackInstagram from "../../images/icons/blackInstagram.svg";
import instagramImage1 from "../../images/instagramImage1.png";
import instagramImage2 from "../../images/instagramImage2.jpg";
import instagramImage3 from "../../images/instagramImage3.png";
import instagramImage4 from "../../images/instagramImage4.jpg";
import { stayUpToDate } from "../../assets/mockData/stayUpToDate";
import "./homepage.css";

export const Homepage = () => {
  const HeroNewsCard = ({ card, array }) => {
    return (
      <>
        <img className="news-wrapper-image" src={card.image} alt="plants" />
        <div className="news-box">
          <div>
            <Label>NEWS</Label>
            <p className="description-demibold">
              <a href="/#">{card.article}</a>
            </p>
            <div className="news-time-data">
              <p>
                <span>
                  <img src={calendar} alt="calendar" />
                </span>
                {card.date}
              </p>
              <p>
                <span>
                  <img src={clock} alt="clock" />
                </span>
                {card.read} MIN TO READ
              </p>
            </div>
          </div>
          <div className="news-box-bottom">
            <Button type="learn-more-arrow white-text">LEARN MORE</Button>
            <div className="pagination-wrapper">
              {array?.map((el) => (
                <div
                  key={el.article}
                  className={`pagination-dot ${
                    card.article === el.article && "active-dot"
                  }`}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  };

  const NewsCard = ({ card, array }) => {
    return (
      <div className="latest-card">
        <div className="latest-card-image">
          <img src={card.image} alt={card.article} />
        </div>
        <Label>{card.label}</Label>
        <p className="description-demibold">{card.article}</p>
        <div className="news-time-data">
          <p className="body3">
            <span>
              <img src={blackCalendar} alt="black calendar" />
            </span>
            {card.date}
          </p>
          <p className="body3">
            <span>
              <img src={blackClock} alt="black clock" />
            </span>
            {card.read} MIN TO READ
          </p>
        </div>
        <div className="pagination-wrapper">
          {array?.map((el) => (
            <div
              key={el.article}
              className={`pagination-dot black-background ${
                card.article === el.article && "active-dot"
              }`}
            ></div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <section>
        <div className="container">
          <Header />
          <div className="hero">
            <video autoPlay loop muted>
              <source src={hero} type="video/mp4" />
            </video>
            <h1>
              Ahead
              <br /> of{" "}
              <span className="color-text">
                climate
                <br />
              </span>{" "}
              change.
            </h1>
          </div>
          <div className="information-wrapper">
            <div className="offer-section">
              <p className="description-medium">
                We offer solutions that can
                <br /> respond{" "}
                <span className="color-text">to future climate change</span>
                <br /> and related challenges.
              </p>
              <Button type="white-arrow" />
            </div>
            <div className="box-for-border"></div>
            <div className="box-for-border radius16"></div>
            <div className="box-for-border location-left"></div>
            <div className="box-for-border location-left radius16"></div>
            <div className="news-wrapper">
              <Slider>
                {stayUpToDate?.map((el) => (
                  <Slide key={el.article}>
                    <HeroNewsCard card={el} array={stayUpToDate} />
                  </Slide>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="solutions">
            <p className="description-medium">
              We offer solutions that can{" "}
              <span>
                <br />
              </span>
              respond{" "}
              <span className="color-text">to future climate change</span>
              <span>
                <br />
              </span>{" "}
              and related challenges.
            </p>
            <SolutionCard
              image={variant1}
              numbers="22+"
              description="years in agricultural industry"
              position="first"
            />
            <SolutionCard
              image={folder}
              numbers=">150"
              description="conducted research with our products"
              position="second"
            />
            <SolutionCard
              image={agricultureIcon}
              numbers="15"
              description="partners in various countries"
              position="third"
            />
            <SolutionCard
              image={plants}
              numbers="95%"
              description="increase yields with our solutions"
              position="fourth"
            />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="family-business">
            <LabelButton>ABOUT US</LabelButton>
            <h1>
              <span className="black-text">A family business philosophy</span>
              <span className="display-none-mobile">
                <br />
              </span>{" "}
              born in{" "}
              <span>
                <img
                  className="family-business-flag"
                  src={EuropeFlag}
                  alt="Europe flag"
                />
              </span>{" "}
              Europe<span className="black-text">, with solutions</span> made in{" "}
              <span>
                <img
                  className="family-business-flag"
                  src={GermanFlag}
                  alt="German flag"
                />
              </span>{" "}
              Germany
            </h1>
            <div className="description">
              <h4>
                <span className="black-text">
                  We’re part of a global movement of people, organizations, and
                  companies who work together towards a common goal —
                </span>{" "}
                to tackle the challenge of the climate crisis{" "}
                <span className="black-text">
                  and to make a meaningful contribution to secure the future of
                  humanity.
                </span>
              </h4>
              <Button type="learn-more-arrow">LEARN MORE ABOUT US</Button>
            </div>
          </div>
        </div>
      </section>
      <section className="safer-harvests">
        <div className="container">
          <div className="safer-harvests-first">
            <h1>
              Ensuring safer
              <br /> harvests in an unsafer environment
            </h1>
          </div>
          <div className="safer-harvests-second">
            <div className="union">
              <div className="safer-harvest-text">
                <div className="union-number one"></div>
                <p className="description-medium">
                  We at UniferX cannot revert climate change, but we can help to
                  change its impact on agriculture, thereby ensuring a safer
                  supply of crops and food - for today as well as tomorrow.
                </p>
              </div>
              <div className="safer-harvest-text">
                <div className="union-number two"></div>
                <p className="description-medium">
                  At UniferX, we strive to combine the qualities of a
                  responsible, dynamic international company with originality
                  and uniqueness with the benefits of a family business
                  philosophy - a philosophy guided by European values and
                  solutions made in Germany.
                </p>
              </div>
              <div className="safer-harvest-text">
                <div className="union-number three"></div>
                <p className="description-medium">
                  We offer intelligent solutions that enable plants to adapt to
                  constantly changing climatic and environmental conditions.
                  High-performance, environmentally friendly products and
                  technologies for agriculture, inspired by nature and
                  respecting nature.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="our-products">
            <div className="products-button-wrapper">
              <LabelButton>PRODUCTS</LabelButton>
            </div>
            <div className="our-products-wrapper">
              <h2>
                Our products
                <br />{" "}
                <span className="black-text">
                  are more than just fertilizers
                </span>
              </h2>
              <div className="our-products-item first black-text">
                <h3>Organic line</h3>
                <div>
                  <img src={betinoTitle} alt="Betino title" />
                </div>
                <Button type="learn-more-arrow" />
              </div>
              <div className="our-products-item second black-text">
                <h3>Wuxal</h3>
                <div>
                  <img src={wuxalTitle} alt="Wuxal title" />
                </div>
                <Button type="learn-more-arrow" />
              </div>
              <div className="our-products-item third black-text">
                <h3>Fertiplant</h3>
                <div>
                  <img src={fertiplantTitle} alt="Fertiplant title" />
                </div>
                <Button type="learn-more-arrow" />
              </div>
              <div className="our-products-item fourth black-text">
                <h3>UniferX</h3>
                <div>
                  <img src={UniferXTitle} alt="UniferX title" />
                </div>
                <Button type="learn-more-arrow" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="trial-results">
            <h2>
              Discover our <span className="color-text">trial results</span>
              <br />
              <span className="color-text"> & crop nutrition programs</span>
            </h2>
            <div className="results-wrapper">
              <div className="trial-results-wrapper">
                <div className="trial-results-up">
                  <img src={charts} alt="charts" />
                </div>
                <div className="trial-results-down">
                  <h4>Trial results</h4>
                  <p className="body1">
                    Here you can find our trial results and
                    <br />
                    conclusions on the effectiveness of our
                    <br /> products in increasing yields.
                  </p>
                  <Button type="learn-more-arrow" />
                </div>
              </div>
              <div className="crop-nutrition">
                <div>
                  <h4>Crop nutrition programs</h4>
                  <p className="body1">
                    Learn how to care for your plants, providing them with
                    proper nutrition for maximum crop yield and health.
                  </p>
                  <Button type="learn-more-arrow" />
                </div>
              </div>
              <div className="information-materials">
                <h4>Information materials</h4>
                <p className="body1">
                  Check out our product catalogs, which contain detailed
                  information on composition and application in PDF format.
                </p>
                <Button type="learn-more-arrow" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="up-to-date">
            <div className="head">
              <div>
                <LabelButton>STAY UP TO DATE</LabelButton>
              </div>
              <h2>Latest research, news & events</h2>
            </div>
            <div className="up-to-date-description-wrapper">
              <div className="up-to-date-description">
                <p className="description-medium">
                  <span>We're constantly</span> publishing fresh news and
                  research
                  <span>
                    , that will help expand your knowledge of the current
                  </span>{" "}
                  challenges in the agricultural industry.
                </p>
                <Button type="learn-more-arrow">VIEW ALL NEWS</Button>
              </div>
              <div className="latest-cards-container">
                {stayUpToDate?.map((el) => (
                  <NewsCard card={el} key={el.article} />
                ))}
              </div>
              <div className="cards-mobile">
                <Slider>
                  {stayUpToDate?.map((el) => (
                    <Slide key={el.article}>
                      <NewsCard card={el} array={stayUpToDate} />
                    </Slide>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="instagram-news">
            <div className="instagram-image-wrapper">
              <h1>Follow our news on Instagram</h1>
              <img src={blackInstagram} alt="instagram" />
            </div>
            <div className="first-instagram-card">
              <InstagramCard image={instagramImage1} />
            </div>
            <div className="second-instagram-card">
              <InstagramCard image={instagramImage2} />
            </div>
            <div className="third-instagram-card">
              <InstagramCard image={instagramImage3} />
            </div>
            <div className="fourth-instagram-card">
              <InstagramCard image={instagramImage4} />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="feedback">
            <div className="feedback-left-side">
              <LabelButton>GET IN TOUCH</LabelButton>
              <div className="yields">
                <h2>
                  Increase
                  <br /> <span className="color-text">yields</span> with us
                </h2>
              </div>
            </div>
            <CTAForm />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
